<template>
    <div>
        <template v-for="item in items">
            <slot :item="item" :is-current="isCurrent(item)" :select="select">
                {{ item.body }}
            </slot>
        </template>
        <infinite-loading @infinite="performLoading" spinner="waveDots" :distance="600" :identifier="infiniteLoadKey">
            <span slot="no-more"></span>
            <template slot="no-results">
                <h5><span class="badge badge-secondary">No results</span></h5>
            </template>
            <template v-slot:error="{ trigger }">
                <h5><span class="badge badge-danger">Whoops. It looks like the server is unavailable.</span>
                </h5>
                <div class="text-center">
                    <el-button size="mini" @click="trigger()">Retry</el-button>
                </div>
            </template>
        </infinite-loading>
    </div>
</template>

<script>
  import BaseList from '../list';

  export default {
    extends: BaseList,

    components: {
      //
    },

    data() {
      return {
        //
      };
    },

    computed: {
      //
    },

    watch: {
      //
    },

    methods: {
      /**
       * @param {Object} item
       * @return {Boolean}
       */
      isCurrent(item) {
        return item === this.current;
      },
    }

  }
</script>
